import { lazy } from 'react'

import AddPackageLoader from './add-package/loader'
import SetupPackageLoader from './setup-package/loader'
import CreateRuleLoader from './create-rule/loader'
import ViewRuleLoader from './view-rule/loader'
import EditRuleLoader from './edit-rule/loader'
import CopyRuleLoader from './copy-rule/loader'
import ManagePackageLoader from './manage-package/loader'

export default {
  AddPackage: {
    Component: lazy(() => import('./add-package/AddPackage.Page')),
    Loader: AddPackageLoader,
  },
  SetupPackage: {
    Component: lazy(() => import('./setup-package/SetupPackage.Page')),
    Loader: SetupPackageLoader,
  },
  ManagePackage: {
    Component: lazy(() => import('./manage-package/ManagePackage.Page')),
    Loader: ManagePackageLoader,
  },
  CreateRule: {
    Component: lazy(() => import('./create-rule/CreateRule.Page')),
    Loader: CreateRuleLoader,
  },
  ViewRule: {
    Component: lazy(() => import('./view-rule/ViewRule.Page')),
    Loader: ViewRuleLoader,
  },
  EditRule: {
    Component: lazy(() => import('./edit-rule/EditRule.Page')),
    Loader: EditRuleLoader,
  },
  CopyRule: {
    Component: lazy(() => import('./copy-rule/CopyRule.Page')),
    Loader: CopyRuleLoader,
  },
}
